(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nmcjs"] = factory();
	else
		root["nmcjs"] = root["nmcjs"] || {}, root["nmcjs"]["public"] = factory();
})(self, () => {
return 